import React, { useEffect, useState } from "react";
import useForm from './hooks/useForm';
import { useNavigate } from "react-router-dom";
import { FormField, LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from './hooks/useFetch';
import useMe from './hooks/useMe';
import {
  Page,
  MazeOverlay,
  Card,
  BrandLogo,
  Head,
  Title,
  Subtitle,
  FieldWrap,
  fieldLabelStyle,
  ErrorSlot,
  SubmitRow,
  SubmitButton,
  SpinnerWrap,
  Foot,
  Tagline
} from './sharedComponents/AuthPageLayout';

export default () => {
  const navigate = useNavigate();

  const { userId } = useMe()
  useEffect(() => {
    if (Boolean(userId)) {
      navigate('/')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  const fetch = useFetch();

  const [isBusy, setIsBusy] = useState(false);
  const [showInvalidLogin, setShowInvalidLogin] = useState(false);

  const formSchema = {
    requiredFields: ['email', 'password', 'imitateUserName'],
    initData: {
      email: '',
      password: '',
      imitateUserName: ''
    }
  }

  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    if (formData.isValid()) {
      setIsBusy(true)

      const response = await fetch(
        `auth/adminImitatorLogin`,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(formData.values)
        }
      )

      const jsonData = await response.json() || {};

      const { status = '' } = jsonData;

      if (status) {
        window.location.reload()
      } else {
        setShowInvalidLogin(true)
      }

      setIsBusy(false)
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }

  return (
    <Page>

      <MazeOverlay aria-hidden="true" />

      <Card>

        <BrandLogo />

        <Head>
          <Title>{'Admin Imitator Login'}</Title>
          <Subtitle>{'Sign in with your admin credentials to log in as another user.'}</Subtitle>
        </Head>

        <FieldWrap $invalid={!!formData.missingValues['email']}>
          <FormField
            label='Admin User Name'
            labelStyle={fieldLabelStyle}
            fieldId='email'
            type='text'
            placeholder='you@prosolve.com'
            formData={formData}
            isLoginField={true}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <FieldWrap $invalid={!!formData.missingValues['password']}>
          <FormField
            label='Admin Password'
            labelStyle={fieldLabelStyle}
            fieldId='password'
            type='password'
            placeholder='Enter your password'
            formData={formData}
            isLoginField={true}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <FieldWrap $invalid={!!formData.missingValues['imitateUserName']}>
          <FormField
            label='Imitate User Name'
            labelStyle={fieldLabelStyle}
            fieldId='imitateUserName'
            type='text'
            placeholder='user@district.org'
            formData={formData}
            onKeyDown={onKeyDown}
          />
        </FieldWrap>

        <ErrorSlot>
          { (!isBusy && showInvalidLogin) ? 'Unable to login' : '' }
        </ErrorSlot>

        <SubmitRow>
          <SubmitButton onClick={onClickSubmit}>
            {'Sign In'}
          </SubmitButton>
          {
            isBusy &&
            <SpinnerWrap>
              <LoadingIcon />
            </SpinnerWrap>
          }
        </SubmitRow>

        <Foot>
          <Tagline>{'The Human Skills Company'}</Tagline>
        </Foot>

      </Card>
    </Page>
  )
}
